import React from 'react';
import { Chip, TableRow, Box } from '@mui/material';
import { AntTableCell, useStyles } from '../../../theme/Table';
import dateFormat from 'dateformat';
import { PowerSettingsNew } from '@mui/icons-material';

const Resource = ({
  l7ResourceId,
  l7ResourceName,
  serviceIp,
  partnerClientAccountId,
  l7Protection,
  advancedProtection,
  serviceEnable,
  setIsSwitchOn,
  setIsSwitchOff,
  createdAt,
}) => {
  const classes = useStyles();
  return (
    <TableRow hover>
      <AntTableCell component="th" scope="row">
        {l7ResourceId}
      </AntTableCell>
      <AntTableCell>{l7ResourceName}</AntTableCell>
      <AntTableCell>{serviceIp}</AntTableCell>
      <AntTableCell>{partnerClientAccountId}</AntTableCell>
      <AntTableCell>
        {!l7Protection ? (
          <Chip label="Disabled" style={{ padding: '0 20px' }} />
        ) : (
          <Chip
            label="Active"
            style={{ color: '#00C853', background: '#ECF9F3', padding: '0 20px' }}
          />
        )}
      </AntTableCell>
      <AntTableCell>
        {!advancedProtection ? (
          <Chip label="Disabled" style={{ padding: '0 20px' }} />
        ) : (
          <Chip
            label="Active"
            style={{ color: '#00C853', background: '#ECF9F3', padding: '0 20px' }}
          />
        )}
      </AntTableCell>
      <AntTableCell>{dateFormat(createdAt, 'dd/mm/yy hh:MM:ss')}</AntTableCell>
      <AntTableCell align="center">
        {!serviceEnable ? (
          <Box
            className={classes.statusWrapper}
            onClick={(e) => {
              setIsSwitchOn({
                switchOn: true,
                name: l7ResourceName,
                l7ResourceId: l7ResourceId,
                partnerClientAccountId: partnerClientAccountId,
              });
            }}
          >
            <PowerSettingsNew className={classes.iconPowerOff} />
            <div style={{ margin: '3px 0 0 3px' }}>Off</div>
          </Box>
        ) : (
          <Box
            className={classes.statusWrapper}
            onClick={(e) => {
              setIsSwitchOff({
                switchOff: true,
                name: l7ResourceName,
                l7ResourceId: l7ResourceId,
                partnerClientAccountId: partnerClientAccountId,
              });
            }}
          >
            <PowerSettingsNew className={classes.iconPowerOn} />
            <div style={{ margin: '3px 0 0 3px' }}>On</div>
          </Box>
        )}
      </AntTableCell>
    </TableRow>
  );
};

export default Resource;
